import { QaEquipmentCatalogDto, QaEquipmentRtSystemDto } from '@/api/generator';
import { orderCompare } from '@/utils/compareAndSort';

const subCategoryOrder = [
  'ArrayDetector',
  'Phantom',
  'WaterTank',
  'SingleDetector',
  'OtherDetector',
  'Electrometer',
  'DetectorHolder',
  'Accessory',
  'Interface',
  'OtherDosimetryQaEquipment',
];

const compareSubCategory = orderCompare(subCategoryOrder);

export function subCategoryCompare(
  a: QaEquipmentRtSystemDto | QaEquipmentCatalogDto,
  b: QaEquipmentRtSystemDto | QaEquipmentCatalogDto,
) {
  return compareSubCategory(a.subCategory, b.subCategory);
}

export function sortedQaEquipment(list?: (QaEquipmentRtSystemDto | QaEquipmentCatalogDto)[]) {
  return list?.toSorted(subCategoryCompare);
}
